import React, { useState, useEffect, useMemo } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import { toast, ToastContainer } from 'react-toastify';
import { getData, postData } from '../../../serverRequest.js';
import moment from 'moment';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Modal from 'react-modal';
import DatePicker from "react-datepicker";
import AttendanceToolbar from './AttendanceToolbar.js';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-toastify/dist/ReactToastify.css';
import '../../../AttendanceCalendar.css';
import { status } from '../../../components/data/data.js';
import LoadingSpinner from "../../../components/Loadder";

export default function UserAttendanceCalendar() {
  const [isApprover, setApprover] = React.useState(JSON.parse(localStorage.getItem('companyApprover')));
  const [events, setEvents] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [currentSlot, setCurrentSlot] = useState(null);
  const [attendance, setAttendance] = useState('');
  const [loginTime, setLoginTime] = useState('');
  const [logoutTime, setLogoutTime] = useState('');
  const [remarks, setRemarks] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [editingEvent, setEditingEvent] = useState(null);
  const searchParams = new URLSearchParams(window.location.search);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [currentDate, setCurrentDate] = useState(new Date());
  const [leaveModalIsOpen, setLeaveModalIsOpen] = useState(false);
  const [leaveType, setLeaveType] = useState('');
  const [leaveStartDate, setLeaveStartDate] = useState(null);
  const [leaveEndDate, setLeaveEndDate] = useState(null);
  const [leaveReason, setLeaveReason] = useState('');
  const [approverId, setApproverId] = useState('');
  const [approverlist, setApproverlist] = useState([]);
  const [isSuperadmin, setSuperadmin] = React.useState(JSON.parse(localStorage.getItem('companyAdmin')));
  const [loading, setLoading] = useState(false);
  const [requestedLeaves, setRequestedLeaves] = useState([]);
  const [requestedLeavesType, setRequestedLeavesType] = useState([]);
  const [holidays, setHolidays] = useState([]); // State to store holidays


  const formatApproverList = (approver_list) => {
    let approver_list_data = [];
    if (approver_list) {
      for (let i = 0; i < approver_list.length; i++) {
        approver_list_data.push({ value: approver_list[i]['employee'], label: approver_list[i]['employee_first_name'] })
      }
    }

    return approver_list_data
  }
  useEffect(() => {
    const fetchAttendanceData = async () => {
      // try {
      const apiData = await getData('/api/employee/attendance_record/?employee_id=' + localStorage.getItem('employeeId'));
      if (apiData['data']['attendance_data']) {
        const formattedEvents = apiData['data']['attendance_data'].map(event => ({
          start: new Date(event.date),
          end: new Date(event.date),
          allDay: false,
          className: 'custom-event',
          status: event.status,
          title: event.status === 'P' ? 'Present' : event.status === 'A' ? 'Absent' : event.status === 'H' ? 'Half Day' : event.status === 'W' ? 'WFH' : event.title,
        }));
        setEvents(formattedEvents);
      }
      // try {
      const resData = await getData('/api/employee/leave_request/?employee_id=' + localStorage.getItem('employeeId'));
      if (resData['data']['code'] === 200) {
        const requestLeaves = resData['data']['leave_requests']
          .filter(leave => leave.status !== "R")
          .map(leave => ({
            start: new Date(leave.start_date),
            end: new Date(leave.end_date),
            allDay: true,
            className: 'custom-event',
            title: 'Leave Applied',
            remarks: leave.reason,
          }));
        setRequestedLeaves(requestLeaves);
        setEvents(prevEvents => [...prevEvents, ...requestLeaves]);
      }
      else {
        // toast.error(resData['data']['message']);
        console.log(resData);
        
      }

      // } 
      // catch (error) {
      //   console.error('Error submitting leave request:', error);
      //   toast.error('Failed to submit leave request.');
      // }
      // try {
      const leaveData = await getData('/api/company/leave_type/?company_id=' + localStorage.getItem('companyId'));
      if (leaveData['data']['code'] === 200) {
        const leavesOptions = leaveData['data']['data'].map(leave => ({
          value: leave.id,
          name: leave.type
        }));
        setRequestedLeavesType(leavesOptions);
      }
      else {
        toast.error(leaveData['data']['message']);
      }

      // } catch (error) {
      //   console.error('Error submitting leave request:', error);
      //   toast.error('Failed to submit leave request.');
      // }

      let company_id = localStorage.getItem('companyId')
      let url = '/api/employee/admins/?company_id=' + company_id;
      let adminData = await getData(url)
      let admins_data = adminData['data']
      //console.log(admins_data);
      if (admins_data['approvers']) {
        console.log(admins_data['approvers']);
        let approverData = await formatApproverList(admins_data['approvers'])
        setApproverlist(approverData)
      }

      // Fetch holidays
      try {
        const holidayData = await getData('/api/company/holiday?company_id=' + localStorage.getItem('companyId'));
        if (holidayData && holidayData['data'] && holidayData['data']['data']) {
          const holidaysList = holidayData['data']['data'];
          setHolidays(holidaysList);
          
          // Format holidays as events
          const holidayEvents = holidaysList.map(holiday => ({
            start: new Date(holiday.holiday_date),
            end: new Date(holiday.holiday_date),
            allDay: true,
            className: 'custom-event',
            title: holiday.is_optional ? 'Optional Holiday' : 'Holiday',
            isHoliday: true,
            isOptional: Boolean(holiday.is_optional), // Ensure it's a boolean
            holidayReason: holiday.holiday_reason,
          }));
          
          // Add holiday events to calendar
          setEvents(prevEvents => [...prevEvents, ...holidayEvents]);
        }
      } catch (error) {
        console.error('Error fetching holidays:', error);
      }
      // } catch (error) {
      //   toast.error('Failed to load attendance data.');
      // }
    };

    fetchAttendanceData();
  }, []);

  const saveAttendanceData = async (updatedEvents) => {

    console.log(attendance);
    let reqData = {
      employee_id: localStorage.getItem('employeeId'),
      date: moment(currentSlot.start).format('YYYY-MM-DD'),
      end: moment(currentSlot.end).format('YYYY-MM-DD'),
      remarks: remarks,
      status: attendance,
    }
    console.log(reqData);
    try {
      let loadData = await postData('/api/employee/attendance_record/', reqData);
      if (loadData['data']['code'] === 200) {
        toast.success('Attendance data saved successfully.');
        // window.location.reload();
      }
    } catch (error) {
      console.error('Error saving attendance data:', error);
      toast.error('Failed to save attendance data.');
    }
  };

  const handleSaveAttendance = () => {
    // if (attendance === 'P' || attendance === 'H') {
    //   if (!loginTime || !logoutTime) {
    //    toast.error('Please enter login and logout times for Present or Half Day attendance.');
    //    return;
    //  }
    // }

    if (isEditing && !remarks) {
      toast.error('Remarks are required when editing.');
      return;
    }
    
    const isDateInRequestedLeaves = requestedLeaves.some(leave => {
      const leaveStart = moment(leave.start);
      const leaveEnd = moment(leave.end);
      const currentDate = moment(currentSlot.start);
      return currentDate.isBetween(leaveStart, leaveEnd, 'day', '[]');
    });

    if (isDateInRequestedLeaves) {
      handleCloseModal();
      toast.error('Attendance cannot be marked as the date is already in the requested leaves.');
      return;
    }

    const isSlotConflict = events.some(event => {
      const eventStart = moment(event.start);
      const eventEnd = moment(event.end);
      const slotStart = moment(currentSlot.start);
      const slotEnd = moment(currentSlot.end);
      return slotStart.isBetween(eventStart, eventEnd, 'minute', '[]') || 
             slotEnd.isBetween(eventStart, eventEnd, 'minute', '[]') || 
             eventStart.isBetween(slotStart, slotEnd, 'minute', '[]') || 
             eventEnd.isBetween(slotStart, slotEnd, 'minute', '[]');
    });

    if (isSlotConflict) {
      toast.error('Attendance cannot be marked as the slot conflicts with an existing event.');
      return;
    }

    if (attendance === 'P' || attendance === 'A' || attendance === 'H' || attendance === 'L' || attendance === 'W') {
      const title = attendance === 'P' ? 'Present' : attendance === 'A' ? 'Absent' : attendance === 'L' ? 'Leave' : attendance === 'W' ? 'WFH' : 'Half Day';
      // const formattedLoginTime = attendance !== 'A' ? `Login: ${moment(loginTime, 'hh:mm A').format('hh:mm A')}` : '';
      // const formattedLogoutTime = attendance !== 'A' ? `Logout: ${moment(logoutTime, 'hh:mm A').format('hh:mm A')}` : '';
      const description = `${title}`; //\n${formattedLoginTime}\n${formattedLogoutTime}`;

      let updatedEvents;
      if (isEditing && editingEvent) {
        updatedEvents = events.map(event =>
          event === editingEvent ? { ...event, title: description, remarks } : event
        );
      } else {
        updatedEvents = [
          ...events,
          {
            start: currentSlot.start,
            end: currentSlot.end,
            title: description,
            allDay: true,
            className: 'custom-event',
            remarks,
          },
        ];
      }

      saveAttendanceData(updatedEvents); // Save updated events to the backend
      setEvents(updatedEvents);
      handleCloseModal();
    } else {
      toast.error('Invalid input. Please select Present, Half Day, Absent or Leave.');
    }
  };

  const localizer = momentLocalizer(moment);
  Modal.setAppElement('#root');

  const isValidDate = (date) => {
    const today = moment();
    const pastSevenDays = today.clone().subtract(1, 'days');

    if (moment(date).isBetween(pastSevenDays, today, 'day', '[]')) {
      return false; // Valid for the past 7 days and today (inclusive)
    }
    // All other dates are disabled
    return true;
  };

  const handleSelectSlot = ({ start, end }) => {
    // Check if the selected date is a holiday FIRST (before date validation)
    const selectedDate = moment(start).format('YYYY-MM-DD');
    const holiday = holidays.find(holiday => 
      moment(holiday.holiday_date).format('YYYY-MM-DD') === selectedDate
    );
    
    if (holiday) {
      const holidayType = holiday.is_optional ? 'Optional Holiday' : 'Fixed Holiday';
      const holidayMessage = holiday.holiday_reason 
        ? `Cannot mark attendance on ${holidayType}: ${holiday.holiday_reason}`
        : `Cannot mark attendance on ${holidayType}`;
      toast.error(holidayMessage);
      return;
    }
    
    // Then check date validity
    if (isValidDate(start)) {
      toast.error('Cannot mark attendance beyond previous week and today.');
      return;
    }
    
    setCurrentSlot({ start, end });
    setModalIsOpen(true);
    setIsEditing(false);
    setAttendance('');
    setLoginTime('');
    setLogoutTime('');
    setRemarks('');
  };

  const handleSelectEvent = (event) => {
    // Prevent editing holidays FIRST (before date validation)
    if (event.isHoliday) {
      const holidayType = event.isOptional ? 'Optional Holiday' : 'Fixed Holiday';
      const holidayMessage = event.holidayReason 
        ? `Cannot edit ${holidayType}: ${event.holidayReason}`
        : `Cannot edit ${holidayType}`;
      toast.error(holidayMessage);
      return;
    }
    
    // Then check date validity
    if (isValidDate(event.start)) {
      toast.error('Cannot edit attendance beyond previous week and today.');
      return;
    }
    
    if (event.title) {
      const attendance = event.title.includes('Present') ? 'P' : event.title.includes('Absent') ? 'A' : 'H';
      const loginTime = event.title.match(/Login: (\d{1,2}:\d{2}) (AM|PM)/)?.[0] || '';
      const logoutTime = event.title.match(/Logout: (\d{1,2}:\d{2}) (AM|PM)/)?.[0] || '';
      setCurrentSlot({ start: event.start, end: event.end });
      setAttendance(attendance);
      setLoginTime(loginTime);
      setLogoutTime(logoutTime);
      setRemarks(event.remarks || '');
      setIsEditing(true);
      setEditingEvent(event);
      setModalIsOpen(true);
    }
  };

  const handleCloseModal = () => {
    setModalIsOpen(false);
    setAttendance('');
    setLoginTime('');
    setLogoutTime('');
    setRemarks('');
    setCurrentSlot(null);
    setIsEditing(false);
    setEditingEvent(null);
  };

  const handleSubmitLeaveRequest = async () => {
    setLoading(true);
    const isDateConflict = requestedLeaves.some(leave => {
      const leaveStart = moment(leave.start);
      const leaveEnd = moment(leave.end);
      return moment(leaveStartDate).isBetween(leaveStart, leaveEnd, 'day', '[]') ||
         moment(leaveEndDate).isBetween(leaveStart, leaveEnd, 'day', '[]') ||
         moment(leaveStart).isBetween(leaveStartDate, leaveEndDate, 'day', '[]') ||
         moment(leaveEnd).isBetween(leaveStartDate, leaveEndDate, 'day', '[]');
    });

    const isAttendanceConflict = events.some(event => {
      const eventStart = moment(event.start);
      const eventEnd = moment(event.end);
      return moment(leaveStartDate).isBetween(eventStart, eventEnd, 'day', '[]') ||
         moment(leaveEndDate).isBetween(eventStart, eventEnd, 'day', '[]') ||
         moment(eventStart).isBetween(leaveStartDate, leaveEndDate, 'day', '[]') ||
         moment(eventEnd).isBetween(leaveStartDate, leaveEndDate, 'day', '[]');
    });

    if (isDateConflict) {
      toast.error('Leave dates conflict with already applied leave.');
      setLoading(false);
      return;
    }

    if (isAttendanceConflict) {
      toast.error('Leave dates conflict with already marked attendance.');
      setLoading(false);
      return;
    }
    if (!leaveType || !leaveStartDate || !leaveEndDate || !leaveReason) {
      toast.error('Please fill in all the leave details.');
      setLoading(false);
      return;
    }

    const leaveData = {
      employee_id: localStorage.getItem('employeeId'),
      leave_type: leaveType,
      start_date: moment(leaveStartDate).format('YYYY-MM-DD'),
      end_date: moment(leaveEndDate).format('YYYY-MM-DD'),
      reason: leaveReason,
      approved_by: approverId,
    };

    try {
      const resData = await postData('/api/employee/leave_request/', leaveData);
      if (resData['data']['code'] === 200) {
        toast.success('Leave request submitted successfully.');
        const updatedLeaveRequests = [...requestedLeaves, {
          start: new Date(leaveStartDate),
          end: new Date(leaveEndDate),
          allDay: true,
          className: 'custom-event',
          title: 'Leave Applied',
          remarks: leaveReason,
        }];
        setRequestedLeaves(updatedLeaveRequests);
        setEvents(prevEvents => [...prevEvents, ...updatedLeaveRequests]);
        setLeaveModalIsOpen(false);
        setLeaveType('');
        setLeaveStartDate(null);
        setLeaveEndDate(null);
        setLeaveReason('');
        setLoading(false);
        window.location.reload(); // Reload to reflect changes
      }
      else {
        setLoading(false);
        toast.error(resData['data']['message']);
      }

    } catch (error) {
      console.error('Error submitting leave request:', error);
      toast.error('Failed to submit leave request.');
    }
  };

  const handleCloseLeaveModal = () => {
    setLeaveModalIsOpen(false);
    setLeaveType('');
    setLeaveStartDate(null);
    setLeaveEndDate(null);
    setLeaveReason('');
  };

  const eventPropGetter = (event) => {
    let bgColor = '';
    let customStyle = { whiteSpace: 'pre-wrap' };
    
    // Handle holiday colors
    if (event.isHoliday) {
      if (event.isOptional === true || event.isOptional === 'true' || event.isOptional === 1) {
        // Orange for optional holidays
        bgColor = 'bg-orange-500';
        customStyle.backgroundColor = '#f97316'; // Orange-500 color as fallback
      } else {
        // Dark blue for fixed holidays
        bgColor = 'bg-blue-800';
        customStyle.backgroundColor = '#1e3a8a'; // Blue-800 color as fallback
      }
    } else if (event.title) {
      bgColor = event.title.includes('Present')
        ? 'bg-green-500'
        : event.title.includes('Absent')
          ? 'bg-red-500'
          : event.title.includes('Leave')
            ? 'bg-blue-500'
            : event.title.includes('Leave Applied')
              ? 'bg-gray-500'
              : 'bg-yellow-500';
    }

    return {
      className: `custom-event text-white ${bgColor} p-1 rounded relative`,
      style: customStyle,
    };
  };

  const EventComponent = ({ event }) => (
    <div className="flex items-center justify-between">
      {event.title ? (
        <div dangerouslySetInnerHTML={{ __html: event.title.replace(/\n/g, '<br>') }} />
      ) : ''}
    </div>
  );

  // Filter events based on selected date range
  const filteredEvents = useMemo(() => {
    if (!startDate || !endDate) {
      return events; // Return all events if no date range is selected
    }
    
    return events.filter(event => {
      const eventDate = moment(event.start);
      return eventDate.isSameOrAfter(moment(startDate).startOf('day')) && 
             eventDate.isSameOrBefore(moment(endDate).endOf('day'));
    });
  }, [events, startDate, endDate]);

  // Auto-navigate calendar to selected date range
  useEffect(() => {
    // When a date range is selected, navigate calendar to the start date
    if (startDate) {
      setCurrentDate(new Date(startDate));
    }
  }, [startDate, endDate]);

  const handleDownload = (type) => {
    // Use filtered events if date range is selected, otherwise use all events
    const eventsToDownload = (startDate && endDate) ? filteredEvents : events;
    
    const data = eventsToDownload.map(event => ({
      Date: moment(event.start).format("YYYY-MM-DD"),
      Attendance: event.title,
      Remarks: event.remarks || "N/A",
    }));

    if (type === "csv") {
      const csvData = [
        ["Date", "Attendance", "Remarks"],
        ...data.map(row => [row.Date, row.Attendance, row.Remarks])
      ];
      const csvString = csvData.map(row => row.join(",")).join("\n");
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, "user_attendance_report.csv");
    } else if (type === "xlsx") {
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance");
      XLSX.writeFile(workbook, "user_attendance_report.xlsx");
    }
  };

  return (
    <div className="m-5 p-0 pt-0 bg-gray-100 min-h-screen w-full">
      <div className="rounded bg-white px-6 py-6">
        <div className="text-center flex justify-between">
          <h6 className="text-blueGray-700 text-xl py-1 font-bold">Attendance</h6>
          <div className="w-full lg:w-3/12 px-4">
            <div className="relative w-">
              {isApprover ? <>
                <DatePicker
                  selectsRange
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => setDateRange(update)}
                  isClearable
                  placeholderText="Select Date Range"
                  className="w-full lg:w-3/12 mb-3 px-3 py-2 border rounded"
                /></> : ''}
            </div>
          </div>
          <div>
            {isApprover ? <>
              <button
                onClick={() => handleDownload("csv")}
                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-3 py-3 rounded shadow hover:shadow-md outline-none focus:outline-none mr-4 ease-linear transition-all duration-150"
              >
                Download CSV
              </button>
              <button
                onClick={() => handleDownload("xlsx")}
                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-3 py-3 rounded shadow hover:shadow-md outline-none focus:outline-none mr-4 ease-linear transition-all duration-150"
              >
                Download Excel
              </button>
            </> : ''}
            <button
              onClick={() => setLeaveModalIsOpen(true)}
              className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-3 py-3 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
            >
              Apply Leave
            </button>
          </div>
        </div>
      </div>
      <div className='mt-2 p-2 bg-white rounded shadow'>
        <Calendar
          localizer={momentLocalizer(moment)}
          events={filteredEvents}
          date={currentDate}
          onNavigate={(date) => setCurrentDate(date)}
          startAccessor="start"
          endAccessor="end"
          style={{ height: 550 }}
          selectable
          onSelectSlot={(slotInfo) => {
            const day = moment(slotInfo.start).day();
            if (day=== 0 || day === 6) {
              toast.error('Cannot select weekends.');
              return;
            }
            handleSelectSlot(slotInfo);
          }}
          onSelectEvent={(event) => {
            // Prevent selecting holiday events
            if (event.isHoliday) {
              return;
            }
            handleSelectEvent(event);
          }}
          eventPropGetter={(event) => {
            const day = moment(event.start).day();
            if (day === 0 || day === 6) {
              return {
                className: 'custom-event bg-gray-400 text-white p-1 rounded relative',
                style: { pointerEvents: 'none' },
              };
            }
            return eventPropGetter(event);
          }}
          components={{
            event: EventComponent,
            toolbar: AttendanceToolbar,
          }}
          dayPropGetter={(date) => {
            const day = date.getDay();
            const isToday = moment(date).isSame(moment(), 'day');
            
            if (day === 0 || day === 6) {
              return {
                className: 'rbc-day-disabled rbc-weekend-bg',
                style: {
                  backgroundColor: '#e8f4f8',
                  pointerEvents: 'none',
                  position: 'relative',
                },
              };
            }
            
            if (isToday) {
              return {
                className: 'rbc-today',
                style: {
                  backgroundColor: '#fff9e6',
                },
              };
            }
            
            return {};
          }}
        />
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={handleCloseModal}
          contentLabel="Attendance Input"
        >
          <div className="modal-content px-3 py-2">
            <h2 className="text-blueGray-700 text-xl font-bold text-center">{isEditing ? 'Edit Attendance' : 'Mark Attendance'}</h2>
            <label className="block uppercase text-blueGray-600 text-sm font-bold mb-2" htmlFor="enter-attendance">
              Attendance :
              <select
                className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                value={attendance}
                onChange={e => setAttendance(e.target.value)}>
                <option value="">Select Attendance</option>
                <option value="P">Present</option>
                <option value="A">Absent</option>
                <option value="H">Half Day</option>
                <option value="W">Work From Home</option>
              </select>
            </label>
            <label className="block uppercase text-blueGray-600 text-sm font-bold mb-2">
              Remarks:
              <textarea
                className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                value={remarks}
                onChange={e => setRemarks(e.target.value)}
              />
            </label>
            <button onClick={handleSaveAttendance}
              className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow 
                                 hover:shadow-lg outline-none focus:outline-none mr-1 mt-2 mb-1 w-full ease-linear transition-all duration-150">Save</button>
            <button onClick={handleCloseModal}
              className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow 
                                 hover:shadow-lg outline-none focus:outline-none mr-1 mt-2 mb-1 w-full ease-linear transition-all duration-150">Cancel</button>
          </div>
        </Modal>
        <Modal
          isOpen={leaveModalIsOpen}
          onRequestClose={handleCloseLeaveModal}
          contentLabel="Apply Leave"
        >
          {loading ? (
            <LoadingSpinner></LoadingSpinner>
          ) : (<>
            <div className="modal-content px-3 py-2">
              <h2 className="text-blueGray-700 text-xl font-bold text-center">Apply Leave</h2>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label className="block uppercase text-blueGray-600 text-sm font-bold mb-2" htmlFor="leave-type">
                    Leave Type:
                    <select
                      required="required"
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      value={leaveType}
                      onChange={e => setLeaveType(e.target.value)}
                    >
                      <option value="">Select Leave Type</option>
                      {requestedLeavesType.map(leave => (
                        <option key={leave.value} value={leave.value}>{leave.name}</option>
                      ))}
                    </select>
                  </label>
                </div>
                <div className="w-full md:w-1/2 px-3">
                  <label className="block uppercase text-blueGray-600 text-sm font-bold mb-2" htmlFor="approver-id">
                    Approver:
                    <select
                      required="required"
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      value={approverId}
                      onChange={e => setApproverId(e.target.value)}
                    >
                      <option value="">Select Approver</option>
                      {approverlist.map(approver => (
                        <option key={approver.value} value={approver.value}>{approver.label}</option>
                      ))}
                    </select>
                  </label>
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label className="block uppercase text-blueGray-600 text-sm font-bold mb-2" htmlFor="leave-start-date">
                    Start Date:
                    <DatePicker
                      required="required"
                      selected={leaveStartDate}
                      onChange={date => setLeaveStartDate(date)}
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    />
                  </label>
                </div>
                <div className="w-full md:w-1/2 px-3">
                  <label className="block uppercase text-blueGray-600 text-sm font-bold mb-2" htmlFor="leave-end-date">
                    End Date:
                    <DatePicker
                      required="required"
                      selected={leaveEndDate}
                      onChange={date => {
                        if (date < leaveStartDate) {
                          toast.error('End date cannot be earlier than start date.');
                          return;
                        }
                        setLeaveEndDate(date);
                      }}
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    />
                  </label>
                </div>
              </div>
              <label className="block uppercase text-blueGray-600 text-sm font-bold mb-2" htmlFor="leave-reason">
                Reason:
                <textarea
                  required="required"
                  className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  value={leaveReason}
                  onChange={e => setLeaveReason(e.target.value)}
                />
              </label>
              <button onClick={handleSubmitLeaveRequest}
                className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow 
                                         hover:shadow-lg outline-none focus:outline-none mr-1 mt-2 mb-1 w-full ease-linear transition-all duration-150">Submit</button>
              <button onClick={handleCloseLeaveModal}
                className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow 
                                         hover:shadow-lg outline-none focus:outline-none mr-1 mt-2 mb-1 w-full ease-linear transition-all duration-150">Cancel</button>
            </div></>)}
        </Modal>
      </div>
      <ToastContainer />
    </div>
  );
};
